export default __webpack_public_path__ + "static/media/upArrowWhite.0b2c4d58.svg";